import {
  createSlice,
  // createAsyncThunk
} from '@reduxjs/toolkit';
// import ManageAppsService from 'services/manageApps.service';

// export const getAppsList = createAsyncThunk('appsManage/getPublisherApps', async () => {
//   const res = await ManageAppsService.getAppsList();

//   return res.data;
// });

//status: "init" || "loading" || "error" || "success"
const initialManageCreativeMediaState = {
  iconList: [],
  landscapeList: [],
  screenPosition: [], //'empty, uploadingImage,uploadingVideo etc...
  form_is_changed: false,
  uploadingIconStatus: '',
  selectedIcon: '',
  uploadingLandscapeStatus: '',
  selectedLandscape: '',
};

const manageCreativeMediaSlice = createSlice({
  name: 'manageCreativeMediaSlice',
  initialState: initialManageCreativeMediaState,
  reducers: {
    formIsChanged: (state, action) => {
      state.form_is_changed = action.payload;
    },
    getIconList: (state, action) => {
      state.iconList = action.payload;
    },
    getLandscapeList: (state, action) => {
      state.landscapeList = action.payload;
    },
  },
});

export const manageCreativesMedia_action = manageCreativeMediaSlice.actions;
export default manageCreativeMediaSlice.reducer;
